import React from 'react';
import BaseInputLayout, { COMMON_INPUT_LAYOUT_DEFAULT_PROPS, getBaseInputLayoutProps } from './BaseInputLayout';
import { RadioButtonGroupLayoutProps, RadioButtonGroupLayoutType } from 'framework/form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

const RadioButtonGroupLayout: RadioButtonGroupLayoutType = ({
  options,
  source = '',
  value,
  onChangeCallback,
  onFocusCallback,
  isColumnDirection = false,
  className,
  disabled,
  ...other
}: RadioButtonGroupLayoutProps) => {
  const props = { ...COMMON_INPUT_LAYOUT_DEFAULT_PROPS, ...other };

  return (
    <BaseInputLayout
      {...getBaseInputLayoutProps({ ...props, source })}
      className={className}
      sx={[
        {
          '& .label__wrapper': { mb: isColumnDirection ? '4px' : '-4px' },
          '& .MuiFormGroup-root': { minHeight: 'calc(1.4375em + 33px)' },
          '& > .MuiFormHelperText-root:not(:empty)': { mt: '-8px' },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <RadioGroup
        id={source}
        row={!isColumnDirection}
        aria-labelledby={`${source}-radios`}
        name={source}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (onFocusCallback) {
            onFocusCallback();
          }

          if (onChangeCallback) {
            onChangeCallback({
              [source]: (event.target as HTMLInputElement).value,
            });
          }
        }}
      >
        {options?.map(item => (
          <Stack key={item.value} direction="row" alignItems="center" justifyContent="space-between" sx={item.sx}>
            <FormControlLabel
              disabled={disabled || item.disabled || false}
              value={item.value}
              label={item.label}
              control={<Radio sx={{ '& .MuiSvgIcon-root': { width: '20px', height: '20px' } }} />}
            />
            {item.endAdornment}
          </Stack>
        ))}
      </RadioGroup>
    </BaseInputLayout>
  );
};

export default RadioButtonGroupLayout;
